import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as RB from "react-bootstrap";
import DataTable from "react-data-table-component";
import FilterComponent from "../FilterComponent";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import { Delete, Visibility, Download } from "@mui/icons-material";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";

function List(props) {
  const [claimList, setClaimList] = useState([]);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const countPerPage = 10;
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const primaryMenuRes = useSelector(
    (state) => state?.primaryMenu?.primaryMenu?.permissions
  );
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const handleAddClick = (e) => {
    const propdata = {
      mode: "add",
    };
    props.onChange(propdata);
  };
  const columns = [
    {
      name: "Order No",
      selector: (row) => row?.ordersdata?.order_id,
    },
    {
      name: "Invoice No",
      selector: (row) => row?.pi_response?.main_invoice_no,
    },
    {
      name: "Distributor Name",
      selector: (row) => row?.ordersdata?.channel_partner_name,
    },
    {
      name: "Reason",
      selector: (row) => row.claim_type,
    },
    {
      name: "Date",
      selector: (row) =>
        moment(row.pi_response?.main_invoice_date).format("DD-MM-yyyy"),
    },
    {
      name: "Status",
      selector: (row) =>
        row.operator_status === "1"
          ? "Accepted"
          : row.operator_status === "2"
          ? "Rejected"
          : "",
    },

    ...(utils.hasPermission(
      primaryMenuRes,
      "Sales Order Claims",
      "sales_order_claims.view"
    )
      ? [
          {
            name: "View",
            cell: (row) => (
              <>
                <RB.Button
                  className="btn-circle"
                  variant="outline-primary"
                  size="sm"
                  onClick={handleView(row)}
                >
                  <Visibility />
                </RB.Button>
              </>
            ),
            center: true,
          },
        ]
      : []),
  ];

  useEffect(() => {
    getclaimList();
  }, [page, userProfile?.id]);

  const getclaimList = () => {
    var bodyFormData = new FormData();

    bodyFormData.append("page", page);
    bodyFormData.append("per_page", countPerPage);

    utils
      .callAPI(
        "get",
        `sales/getDealerClaimList?page=${page}&per_page=${countPerPage}`
      )
      .then((res) => {
        if (typeof res !== "undefined") {
          setClaimList(res);
        } else {
          setClaimList([]);
        }
      })
      .catch((err) => {
        setClaimList([]);
      });
  };

  const handelEdit = useCallback((row) => async () => {
    const propdata = {
      mode: "edit",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const handleView = useCallback((row) => async () => {
    const propdata = {
      mode: "view",
      rowData: row,
    };
    props.onChange(propdata);
  });

  const showDelete = useCallback((row) => async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        utils
          .callAPI("post", `/sales/getDelete?id=${row.id}`, "")
          .then((res) => {
            if (typeof res !== "undefined") {
              getclaimList();
            }
          })
          .catch((err) => {});
      }
    });
  });

  // const handleDownload = (row) => {
  //   window.open(row.document_link, "_blank");
  // };

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <div className="section-body">
      <RB.Card className="card shadow ">
        <RB.Card.Header>
          <h4></h4>
          <div className="card-header-action">
            {/* {utils.hasPermission(primaryMenuRes, "Quotation", "quotation.create") && ( */}

            {/* )} */}
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          {utils.hasPermission(
            primaryMenuRes,
            "Sales Order Claims",
            "sales_order_claims.view"
          ) && (
            <DataTable
              columns={columns}
              data={claimList.result}
              highlightOnHover
              responsive
              pagination
              paginationServer
              paginationTotalRows={claimList.total}
              paginationPerPage={countPerPage}
              paginationComponentOptions={{
                noRowsPerPage: true,
              }}
              striped
              onChangePage={(page) => setPage(page)}
              persistTableHead
              customStyles={{
                head: {
                  style: {
                    fontSize: "0.875rem", // Adjust the font size as needed
                    fontWeight: "bold", // Adjust the font weight as needed
                  },
                },
              }}
              // subHeader
              // subHeaderComponent={subHeaderComponent}
            />
          )}
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default List;
